import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get () {
    return ApiService.get('user/dashboard/statistics')
  }
}

export default DashboardService
